import React from "react";
import { Box } from "@mui/material";
import Shipping from "../Shipping";
import SettingsCard from "../shared/SettingsCard";
import useTranslation from "../../../../shared/hooks/useTranslation";

const SettingsShipping: React.FC = () => {
  const { translate } = useTranslation("settings");

  return (
    <SettingsCard
      title={translate("settings:shipping.title")}
      subtitle={translate("settings:shipping.description")}
      animationDelay="0.15s"
    >
      <Shipping />
    </SettingsCard>
  );
};

export default SettingsShipping;
